module.exports = __webpack_public_path__ + "img/landing-invest-banner-mark-mini.b25f68be.svg";